import React from "react";
import { Progress } from "reactstrap";
import resStyles from "../css/scanningSessionResponsive.module.scss";

interface MobileHeaderProps {
  sessionData: any;
  activeTab: "select" | "step1" | "step2";
  toggleTab: (tab: "select" | "step1" | "step2") => void;
  handleUpdateStatus: (
    status: "paused" | "completed" | "active",
    shouldNavigate?: boolean
  ) => void;
  setShowProgressModal: (show: boolean) => void;
  completedSubsCount?: number;
  inProgressSubsCount?: number;
}

const MobileScanningHeader: React.FC<MobileHeaderProps> = ({
  sessionData,
  activeTab,
  toggleTab,
  handleUpdateStatus,
  setShowProgressModal,
  completedSubsCount,
}) => {
  const skippedSubs = sessionData?.skipped_subjects ?? 0;
  const totalSubs = sessionData?.totalsubjects ?? 0;
  const rawCompleted = completedSubsCount !== undefined
    ? completedSubsCount
    : ((sessionData?.completed_subjects ?? 0) + skippedSubs);
  const completedSubs = Math.min(rawCompleted, totalSubs);

  return (
    <div className={resStyles.compactHeaderSection}>
      <div className={resStyles.headerTopRow}>
        <div className={resStyles.compactHeaderLeft}>
          <button
            type="button"
            className={resStyles.compactBackBtn}
            onClick={() => {
              if (activeTab === "select") {
                handleUpdateStatus("paused", true);
              } else {
                toggleTab("select");
              }
            }}
          >
            <i className="ri-arrow-left-line"></i>
          </button>
          <div className="d-flex align-items-center gap-2">
            <span className="d-block text-dark fw-bold" style={{ fontSize: "14px" }}>Active Session</span>
            <span className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 ms-2">
              {sessionData?.sessionno || sessionData?.sessionid || "-"}
            </span>
            {sessionData?.display_status === "ACTIVE" ? (
              <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 ms-1 d-flex align-items-center gap-1" style={{ fontSize: "10px" }}>
                <i className="ri-play-circle-fill"></i> Active
              </span>
            ) : sessionData?.display_status === "PAUSED" ? (
              <span className="badge bg-warning bg-opacity-10 text-warning border border-warning border-opacity-25 ms-1 d-flex align-items-center gap-1" style={{ fontSize: "10px" }}>
                <i className="ri-pause-circle-fill"></i> Paused
              </span>
            ) : null}
          </div>
        </div>

        <button
          type="button"
          className={resStyles.compactProgressBtn}
          onClick={() => setShowProgressModal(true)}
          title="View Detailed Progress"
        >
          <div className={resStyles.progressBtnLeft}>
            <span className={resStyles.progressBtnVal}>
              {completedSubs}/
              {totalSubs}
            </span>
            <span className={resStyles.progressBtnLabel}>Subs</span>
          </div>
          <div className={resStyles.progressBtnRight}>
            <i className="ri-pie-chart-2-line"></i>
          </div>
        </button>
      </div>

      <Progress className={resStyles.compactProgressBar} value={(completedSubs / (totalSubs)) * 100} color="success" />

      <div className={resStyles.compactMetadataGrid}>
        <div className={resStyles.metaPairRow}>
          <div className={resStyles.metaItem}>
            <span className={resStyles.metaLabel}>Study:</span>
            <strong className={resStyles.metaValue}>{sessionData?.studycode || "-"}</strong>
          </div>
          <span className={resStyles.desktopDivider}>|</span>
          <div className={resStyles.metaItem}>
            <span className={resStyles.metaLabel}>Period:</span>
            <strong className={resStyles.metaValue}>{sessionData?.period_number || "-"}</strong>
          </div>
        </div>

        <span className={resStyles.desktopDivider}>|</span>

        <div className={resStyles.metaPairRow}>
          <div className={resStyles.metaItem}>
            <span className={resStyles.metaLabel}>Time Point:</span>
            <strong className={resStyles.metaValue}>{sessionData?.timepoint_number || "-"}</strong>
          </div>
          <span className={resStyles.desktopDivider}>|</span>
          <div className={resStyles.metaItem}>
            <span className={resStyles.metaLabel}>Dosing Station:</span>
            <strong className={`${resStyles.metaValue} text-primary`}>
              {`DS-${sessionData?.dosingstationno ? String(sessionData.dosingstationno).padStart(2, "0") : "01"}`}
            </strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileScanningHeader;
